var map = {
	"./dashboard/Main": 209,
	"./dashboard/Main.jsx": 209,
	"./dashboard/i18n": 4,
	"./dashboard/i18n.js": 4,
	"./dashboard/icons/client": 37,
	"./dashboard/icons/client.svg": 37,
	"./dashboard/icons/income": 38,
	"./dashboard/icons/income.svg": 38,
	"./dashboard/icons/spends": 40,
	"./dashboard/icons/spends.svg": 40,
	"./dashboard/icons/therapist-illustration": 43,
	"./dashboard/icons/therapist-illustration.svg": 43,
	"./dashboard/icons/time": 39,
	"./dashboard/icons/time.svg": 39,
	"./dashboard/icons/warn-ico": 44,
	"./dashboard/icons/warn-ico.svg": 44,
	"./dashboard/styled/Card": 8,
	"./dashboard/styled/Card.jsx": 8,
	"./dashboard/styled/Grid": 12,
	"./dashboard/styled/Grid.jsx": 12,
	"./dashboard/styled/Title": 50,
	"./dashboard/styled/Title.jsx": 50,
	"./dashboard/wrappers/ClientSourcing": 47,
	"./dashboard/wrappers/ClientSourcing.jsx": 47,
	"./dashboard/wrappers/ClientsDemography": 46,
	"./dashboard/wrappers/ClientsDemography.jsx": 46,
	"./dashboard/wrappers/ClientsGender": 48,
	"./dashboard/wrappers/ClientsGender.jsx": 48,
	"./dashboard/wrappers/CurrentSpends": 225,
	"./dashboard/wrappers/CurrentSpends.jsx": 225,
	"./dashboard/wrappers/GeneralInfo": 49,
	"./dashboard/wrappers/GeneralInfo.jsx": 49,
	"./dashboard/wrappers/Goal": 36,
	"./dashboard/wrappers/Goal.jsx": 36,
	"./dashboard/wrappers/IncomeGoal": 226,
	"./dashboard/wrappers/IncomeGoal.jsx": 226,
	"./dashboard/wrappers/LineChart": 41,
	"./dashboard/wrappers/LineChart.jsx": 41,
	"./dashboard/wrappers/SuggestedCharge": 42,
	"./dashboard/wrappers/SuggestedCharge.jsx": 42,
	"./dashboard/wrappers/TotalSpends": 45,
	"./dashboard/wrappers/TotalSpends.jsx": 45,
	"./dashboard/wrappers/WorkingHoursGoal": 227,
	"./dashboard/wrappers/WorkingHoursGoal.jsx": 227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 258;